import axiosInstance from "./axiosInstance";

// GET Page by ID
export const getPageById = async (id) => {
  try {
    const response = await axiosInstance.get(`/page/${id}`);
    return response.data.data; // same as your home API
  } catch (error) {
    console.error("Failed to fetch Page:", error);
    throw error;
  }
};